import { IconAvatar } from '@medifind/icons';
import { useRouter } from '@medifind/router';
import { useAuthentication } from '@medifind/zustand';
import AdWrapper from './adWrapper';

const ClaimYourProfileAd = ({ ...props }) => {
  const { decodedToken } = useAuthentication();
  const hasPMAccount = decodedToken?.hasPMAccount;
  const router = useRouter();

  return (
    <>
      {!hasPMAccount && (
        <AdWrapper
          {...props}
          icon={<IconAvatar size={'small'} />}
          title={`Are you the provider on this profile?`}
          onClick={() => router.history.push('/profile-management/sign-up')}
          buttonText={`Claim Profile`}
        />
      )}
    </>
  );
};

export { ClaimYourProfileAd as default, ClaimYourProfileAd };
